import React, { useState } from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';

const CreateWithAIForm = ({ defineAudienceName, setDefineAudienceName, defineAudienceText, setDefineAudienceText, previewLoading, handleDefineSubmit, toggle }) => {
  return (
    <form onSubmit={handleDefineSubmit}>
      <div className="mb-3">
        <Label htmlFor="defineAudienceName" className="form-label">Name</Label>
        <Input 
          type="text"
          className="form-control"
          id="defineAudienceName"
          placeholder="Enter name"
          name="name"
          value={defineAudienceName}
          onChange={(e) => setDefineAudienceName(e.target.value)} 
        />
      </div>

      <div className="mb-3">
        <FormGroup>
          <Label for="osTypeSelect" className="form-label">OS Type</Label>
          <Input type="select" name="defineOsType" id="defineOsTypeSelect" className="form-control">
            <option>ANDROID</option>
            <option>IOS</option>
            <option>MIXED</option>
          </Input>
        </FormGroup>

        <FormGroup>
          <Label for="userStatusSelect">User Status</Label>
          <Input type="select" name="userStatus" id="defineUserStatusSelect" className="form-control">
            <option>ACTIVE</option>
            <option>INACTIVE</option>
            <option>MIXED</option>
          </Input>
        </FormGroup>

        <Label for="defineAudienceText" className="form-label">Define Audience Text</Label>
        <Input
          type="textarea"
          name="defineAudienceText"
          id="defineAudienceText"
          placeholder="Define your audience here..."
          style={{ minHeight: '200px' }}
          value={defineAudienceText}
          onChange={(e) => setDefineAudienceText(e.target.value)}
        />
      </div>

      <div className="hstack gap-2 justify-content-end">
        <Button type="button" color="light" onClick={toggle}>Close</Button>
        <Button type="submit" color="success" id="addNewMember" disabled={!defineAudienceName.trim() || !defineAudienceText.trim()}>
          Create Audience
        </Button>
      </div>
    </form>
  );
};

export default CreateWithAIForm;
